// 医患绑定
export default [
	{
		path: '/dpbind/create/:id/:teamId?',
		name: 'DpBindPatientCreate',
		component: () => import('@/views/dpbind/create.vue'),
		meta: { title: '医患绑定' }
	},
	{
		path: '/dpbind/list/:id/:teamId?',
		name: 'DpBindPatientList',
		component: () => import('@/views/dpbind/list.vue'),
		meta: { title: '医患绑定' }
	},
	{
		path: '/dpbind/result/:type',
		name: 'DpBindPatientResult',
		component: () => import('@/views/dpbind/result.vue'),
		meta: { title: '医患绑定' }
	},
	{
		path: '/dpbind/form/:formId/:patientId?',
		name: 'DpBindPatientResult',
		component: () => import('@/views/dpbind/base-form.vue'),
		meta: { title: '问卷' }
	},
	{
		path: '/dpbind/show/form',
		name: 'DpBindPatientResultShow',
		component: () => import('@/views/dpbind/base-form.vue'),
		meta: { title: '医患绑定' }
	},
	{
		path: '/patientDetail/doctor/form/:patientId',
		name: 'showFormByDoctor',
		component: () => import('@/views/dpbind/showFormByDoctor.vue'),
		meta: { title: '患者问卷' }
	}
]
